import React from 'react'
import OmniSearchBase from 'src/comps/OmniSearch'
import { SearchMode } from 'src/types/search'

import { useSearch } from 'src/hooks/useSearch'

interface IOmniSearchProps {
  readonly mode: SearchMode
  readonly onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  readonly disabled?: boolean
}

export const OmniSearch = ({ mode, onClick, disabled }: IOmniSearchProps) => {
  const { oldSearchUrl } = useSearch()
  return (
    <OmniSearchBase
      mode={mode}
      onClick={onClick}
      preventNavigation={false}
      searchUrl={oldSearchUrl}
      disabled={disabled}
    />
  )
}
